import "core-js/modules/es.array.concat.js";
import React from 'react';
import styled from 'styled-components';
import TextLink from 'components/TextLink';
import { visuallyHidden } from 'styles/mixins';
import { getSpacing } from 'utils/ui';
import { useTranslation } from 'react-i18next';
import { jsx as _jsx } from "react/jsx-runtime";
var id = 'main-content';
var SkipLink = styled(TextLink).withConfig({
  displayName: "SkipNavigationLink__SkipLink",
  componentId: "sc-1mm9x1b-0"
})(["", " &:focus{position:fixed;top:0;left:0;width:auto;height:auto;clip:auto;color:", ";background:", ";padding:", ";z-index:", ";}"], visuallyHidden, function (p) {
  return p.theme.links;
}, function (p) {
  return p.theme.background;
}, function (p) {
  return p.theme.globals.spacing.xs;
}, function (p) {
  return p.theme.globals.z.modals;
});
var SkipTarget = styled.div.withConfig({
  shouldForwardProp: function shouldForwardProp(prop) {
    return prop !== 'verticalOffset';
  }
}).withConfig({
  displayName: "SkipNavigationLink__SkipTarget",
  componentId: "sc-1mm9x1b-1"
})(["", ""], function (p) {
  return p.verticalOffset && "\n\t\tmargin-top: -".concat(getSpacing(p.verticalOffset, p.theme), ";\n\t\tpadding-top: ").concat(getSpacing(p.verticalOffset, p.theme), ";\n\t");
});
function SkipNavigationLink(_ref) {
  var children = _ref.children;
  var _useTranslation = useTranslation(),
    t = _useTranslation.t;
  return /*#__PURE__*/_jsx(SkipLink, {
    href: "#".concat(id),
    children: children || t('actions_skip_navigation')
  });
}
function SkipNavigationTarget(_ref2) {
  var _ref2$verticalOffset = _ref2.verticalOffset,
    verticalOffset = _ref2$verticalOffset === void 0 ? 0 : _ref2$verticalOffset,
    children = _ref2.children;
  return /*#__PURE__*/_jsx(SkipTarget, {
    id: id,
    verticalOffset: verticalOffset,
    children: children
  });
}
export { SkipNavigationLink, SkipNavigationTarget };